(() => {
    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;
        let scrollPosition = window.scrollY;
        let headerContainer = document.getElementsByClassName('diu-neos-structure-header')[0];
        let darkLayer = document.getElementsByClassName('diu-neos-structure-header__dark-layer')[0];

        window.addEventListener('scroll', function () {
            if (scrollPosition >= 150 && window.scrollY > scrollPosition) {
                headerContainer.classList.add('js-diu-header--scrolled');
                darkLayer.classList.add('js-diu-header--scrolled');
            } else {
                headerContainer.classList.remove('js-diu-header--scrolled');
                darkLayer.classList.remove('js-diu-header--scrolled');
            }
            scrollPosition = window.scrollY;
        });
    });
})();
